export const downloadCSV = (reports, currentDate) => {
  const totals = reports.reduce(
    (acc, report) => {
      acc.invited += report.invited;
      acc.showedUp += report.showedUp;
      acc.walkIn += report.walkIn;
      acc.interviewed += report.interviewed;
      acc.qualified += report.qualified;
      return acc;
    },
    { invited: 0, showedUp: 0, walkIn: 0, interviewed: 0, qualified: 0 }
  );

  const border = "---------------------------------------------";

  const headerTitle = "LGS STAFF MANAGEMENT SERVICES INCORPORATED";
  const subHeaderTitle = "RECRUITMENT PRODUCTIVITY REPORT";
  const dateHeader = `DATE: ${currentDate}`;

  const columnHeaders = [
    "NAME",
    "NO. OF INVITED APPLICANTS",
    "NO. SHOWED UP",
    "WALK-IN",
    "TOTAL INTERVIEWED",
    "NO.OF QUALIFIED",
    "REMARKS (INDICATE CLIENTS TO ENDORSE)",
  ];

  const csvRows = [
    border,
    headerTitle,
    subHeaderTitle,
    border,
    dateHeader,
    border,
    columnHeaders.join(","),
    border,
    ...reports.map((report) =>
      [
        `"${report.name}"`,
        report.invited,
        report.showedUp,
        report.walkIn,
        report.interviewed,
        report.qualified,
        `"${report.applicants}"`,
      ].join(",")
    ),
    border,
    [
      '"TOTAL"',
      totals.invited,
      totals.showedUp,
      totals.walkIn,
      totals.interviewed,
      totals.qualified,
      "",
    ].join(","),
    border,
  ];

  const csvContent = csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;

  link.setAttribute(
    "download",
    `recruitment_productivity_report_${currentDate}.csv`
  );

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
